/**
 * Genre-display-logik för publika event-vyer.
 *
 * Genre visas om:
 *   1. AI-klassningen är säker nog (confidence >= GENRE_MIN_CONFIDENCE),
 *      ELLER
 *   2. En admin manuellt har satt genren (genreSource === 'admin'
 *      override:ar confidence-tröskeln).
 *
 * Tidigare gjordes också en auth-gate (bara inloggade fick se genre) —
 * den togs bort i favör av enklare publik visning. Behåll funktionen
 * som central plats för regeln så vi kan ändra på ett ställe om policyn
 * ändras.
 *
 * Användning i template:
 *   <span v-if="shouldShowGenre(event)">{{ event.genre }}</span>
 */
export const GENRE_MIN_CONFIDENCE = 0.7;

export function shouldShowGenre(event) {
  if (!event || !event.genre) return false;
  if (event.genreSource === "admin") return true;
  if (event.genreSource === "ai") {
    return (event.genreConfidence || 0) >= GENRE_MIN_CONFIDENCE;
  }
  // Saknad source = legacy data utan AI-klassning (manuellt satt genre
  // från tidigare admin-arbete utan source-tracking). Visa den.
  return true;
}
